import { useEffect, useState } from 'react';
import { Box, IconButton, Modal, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getComponent } from '../../services/ComponentServices';

const Notification = () => {
    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.down("sm"));
    const xs = useMediaQuery(theme.breakpoints.down("xs"));
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [avisoImage, setavisoImage] = useState("");

    const obtenerAviso = async () => {
        const response = await getComponent(12, 2);
        if (response.status === 200)
            setavisoImage(response.data[0].image);
    }

    useEffect(() => {
        obtenerAviso();
        setShowNotification(true);
    }, []);

    const hideNotification = () => {
        setShowNotification(false);
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: xs || sm ? '95vw' : '80vw',
        maxHeight: xs || sm ? '95vh' : '90vh',
    };

    return (
        <>
            {showNotification && avisoImage !== '' ? (
                <Modal
                    open={showNotification}
                    onClose={hideNotification}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <img
                            loading="lazy"
                            src={avisoImage}
                            alt="Aviso no te dejes engañar"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                                minWidth: xs || sm ? '90vw' : 'auto'
                            }}
                        />
                        <IconButton
                            aria-label="tooltip button"
                            onClick={hideNotification}
                            sx={{ margin: 0, p: 0, position: 'absolute', right: '5px', top: '5px', color: '#E80000', backgroundColor: 'white' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Modal>
            ) : null}
        </>
    );
};

export default Notification;
